import { style as s } from "typestyle";
import * as Style from "../../../styles";

export const component = s({
  width: "100%",
  display: "flex",
  justifyContent: "center",
  backgroundColor: Style.colors.darkTranslucent100,
  padding: "20px 16px",
  boxSizing: "border-box",
});

export const wrapper = s({
  width: "100%",
  maxWidth: 720,
  aspectRatio: "16 / 9",
});

export const iframe = s({
  display: "block",
  width: "100%",
  height: "100%",
  border: 0,
});
